import { Box, Button, Stack, Typography } from '@mui/material';
import { getTypeColor, getTypeIcon } from '@/utils/nodeTypeMapper';
import { useTranslation } from 'react-i18next';

import { useDeleteEnergyTreeNodesMutation } from '@/api/recalcV2/endpoints/energyTreeNodesApiSlice';

// * Redux
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '@/redux/snackbarSlice';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';

const DeleteNodeTab = ({ clickedNode, handleClose }) => {
  const { t } = useTranslation('energyxplorer-tree-tab', 'common');
  const account = useSelector(getSelectedAccount);
  const dispatch = useDispatch();

  const [deleteEnergyTreeNodes] = useDeleteEnergyTreeNodesMutation();

  const handleDeleteNode = async () => {
    try {
      await deleteEnergyTreeNodes({
        accountId: account.AccountId,
        energyTreeNodeId: clickedNode.energyTreeNodeId,
      }).unwrap();
      dispatch(showSnackbar({ message: 'Node fjernet', severity: 'success' }));
      handleClose();
    } catch (error) {
      dispatch(
        showSnackbar({
          message: 'Der opstod en fejl i fjernelse af node',
          severity: 'error',
          response: error,
        }),
      );
    }
  };

  return (
    <Stack spacing={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight={600}>
          {clickedNode?.name || 'Node Details'}
        </Typography>
        <Box
          sx={{
            backgroundColor: getTypeColor(clickedNode?.type),
            borderRadius: '25px',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: `1px solid divider`,
          }}
        >
          <i
            className={`fa-solid ${getTypeIcon(clickedNode?.type)}`}
            style={{ color: 'white' }}
          ></i>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column">
        <Typography variant="body2" color="text.secondary">
          {t('tree_actions.delete_node_confirmation')}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="end" mt={2}>
        <Button
          variant="contained"
          onClick={handleDeleteNode}
          disableElevation
          color="error"
        >
          {t('tree_actions.delete_node')}
        </Button>
      </Box>
    </Stack>
  );
};

export default DeleteNodeTab;
